<template>
  <div>
    <h2>Contactar a Cliente</h2>
    <select v-model="selectedClient">
      <option v-for="client in clients" :key="client.phone" :value="client">
        {{ client.name }} - {{ client.phone }}
      </option>
    </select>

    <textarea v-model="message" placeholder="Escribe tu mensaje aquí"></textarea>

    <button @click="sendMessage">Enviar Mensaje</button>

    <p v-if="status">{{ status }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clients: [],  // Lista de clientes que será cargada
      selectedClient: null,  // Cliente seleccionado para enviar el mensaje
      message: '',  // Contenido del mensaje
      status: ''  // Estado del envío del mensaje
    };
  },
  methods: {
    // Función para enviar el mensaje SMS
    async sendMessage() {
      if (!this.selectedClient || !this.message) {
        this.status = 'Por favor, selecciona un cliente y escribe un mensaje.';
        return;
      }

      try {
        const response = await fetch('https://us-central1-asador-1293f.cloudfunctions.net/sendSmsToClient', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: this.selectedClient.name,
            phone: this.selectedClient.phone,
            message: this.message
          })
        });

        if (!response.ok) throw new Error('Error al enviar el mensaje.');

        this.status = 'Mensaje enviado correctamente.';
      } catch (error) {
        console.error(error);
        this.status = 'Error al enviar el mensaje.';
      }
    }
  },
  // Cargar lista de clientes cuando el componente es montado
  mounted() {
    // Ejemplo: los clientes deben ser cargados dinámicamente desde una base de datos
    this.clients = [
      { name: 'Carlos Rivera', phone: '7872369189' },
      { name: 'Laura Velez', phone: '7874087706' }
    ];
  }
};
</script>

<style scoped>
textarea {
  width: 100%;
  height: 100px;
  margin: 10px 0;
}

button {
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>
